import { render, staticRenderFns } from "./notificationList.vue?vue&type=template&id=a73168e4&scoped=true"
import script from "./notificationList.vue?vue&type=script&lang=js"
export * from "./notificationList.vue?vue&type=script&lang=js"
import style0 from "./notificationList.vue?vue&type=style&index=0&id=a73168e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73168e4",
  null
  
)

export default component.exports